// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__155K8","left":"styles_left__2WajH"};